import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { BinaryChoiceRadio, BinaryChoiceSwitch } from '../../common/BinaryChoice';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const BinaryChoiceWidget = () => {
    const [radio, setRadio] = useState('Value A');
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "BinaryChoiceRadio" }), _jsx(Stack, { direction: "row", children: _jsx(BinaryChoiceRadio, { currentValue: radio, onChange: (event, value) => setRadio(value), valueA: 'Value A', valueB: 'Value B' }) }), _jsx(Typography, { variant: "h5", children: "BinaryChoiceSwitch" }), _jsx(Stack, { direction: "row", children: _jsx(BinaryChoiceSwitch, { currentValue: radio, onChange: (event, checked) => setRadio(checked ? 'Value A' : 'Value B'), valueA: 'Value A', valueB: 'Value B', isValueA: (currentValue) => currentValue === 'Value A' }) })] })), [radio]);
    return {
        name: 'BinaryChoice',
        category: 'common',
        component,
    };
};
